const { React } = require("react");
const { Modal } = require("reactstrap");

const CommonDialog = ({
    isShow = true,
    header,
    message,
    data,
    postitiveBtn,
    negativeBtn,
    onCloseFn
}) => {


    return (

        <Modal
            isOpen={isShow}
            size="sm"
            centered
        >
            {header &&
                <div className="modal-header">
                    <h5 className="modal-title mt-0">{header}</h5>
                    <button
                        type="button"
                        onClick={() => {
                            onCloseFn(-1, data)
                        }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            }

            <div className="modal-body" style={{ marginTop: "17px" }}>
                <span>
                    {message}
                </span>

                <button
                    type="button"
                    onClick={() => {
                        onCloseFn(-1, data)
                    }}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    style={{ marginTop: "-17px" }}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-footer">
                {negativeBtn &&
                    <button
                        type="button"
                        onClick={() => {
                            onCloseFn(0, data)
                        }}
                        className="btn btn-secondary "
                        data-dismiss="modal"
                    >
                        {negativeBtn}
                    </button>
                }
                {postitiveBtn &&
                    <button
                        type="button"
                        className="btn  btn-success"
                        onClick={() => {
                            onCloseFn(1, data)
                        }}
                    >
                        {postitiveBtn}
                    </button>
                }
            </div>
        </Modal>
    )
}

export default CommonDialog